/**
 * Android-only layout helpers for v2 `MainScreenBannerGuest`.
 */
import { Platform, type ViewStyle } from 'react-native';
import { androidScaleSize } from '../shared/theme/androidUiParity';
import { appTheme } from '../shared/theme';

export function isBannerGuestMainScreenAndroid(): boolean {
  return Platform.OS === 'android';
}

export function androidBannerGuestHeroColumnLayoutStyle(): ViewStyle {
  /** Must fill the screen so `footerColumn` + `justifyContent: 'flex-end'` anchor CTAs to the bottom (matches iOS). */
  return {
    flex: 1,
  };
}

export function androidBannerGuestFooterPaddingBottom(insets_bottom: number): number {
  return insets_bottom + androidScaleSize(appTheme.spacing.lg);
}

export function androidBannerGuestLangPillStyle(): ViewStyle {
  return {
    minHeight: androidScaleSize(36),
    minWidth: androidScaleSize(100),
  };
}

export function androidBannerGuestCtaMinHeight(): number {
  return androidScaleSize(44);
}

export function androidBannerGuestTopBarPaddingTop(insets_top: number): number {
  return insets_top + androidScaleSize(appTheme.spacing.sm);
}
